import React, {Component} from 'react'
import AnimatedNumber from 'react-animated-number'

import './styles.css'

const formatKg = n => n.toFixed ? n.toFixed(0) : 0
const format = n => {
  if (n.toFixed) {
    return n >= 100 ? n.toFixed(0) : n.toFixed(1)
  }

  return 0
}

class Score extends Component {
  render() {
    const {title, score, showTotal} = this.props
    return (
      <div className="score">
        <span className="score-title">{title}</span>
        <span className="score-value">
          <AnimatedNumber value={score} duration={150} formatValue={format} />
        </span>
        {showTotal &&
          <span className="score-total">
            <AnimatedNumber value={score * 1000} duration={150} formatValue={formatKg} /> kg
          </span>
        }
      </div>
    )
  }
}

export default Score



// WEBPACK FOOTER //
// ./src/components/Scores/Score.js